/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../../google/protobuf/field_mask';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "checking_direct_deposit_account": {
                "nested": {
                  "GetCheckingDirectDepositAccountRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fieldMask": {
                        "type": ".google.protobuf.FieldMask",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetCheckingDirectDepositAccountResponse": {
                    "fields": {
                      "data": {
                        "type": ".squareup.bbfrontend.common.checking_direct_deposit_account.GetCheckingDirectDepositAccountResponse.DirectDepositNumber",
                        "id": 1
                      },
                      "error": {
                        "type": ".squareup.bbfrontend.common.checking_direct_deposit_account.GetCheckingDirectDepositAccountResponse.Error",
                        "id": 2
                      }
                    },
                    "nested": {
                      "DirectDepositNumber": {
                        "fields": {
                          "routingNumber": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountNumberSuffix": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "accountNumberFull": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "Error": {
                        "values": {
                          "UNKNOWN": 0,
                          "UNAUTHORIZED": 1
                        }
                      },
                      "result": {
                        "oneof": ["data", "error"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_direct_deposit_account?.nested?.GetCheckingDirectDepositAccountRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_direct_deposit_account?.nested?.GetCheckingDirectDepositAccountResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_direct_deposit_account?.nested?.GetCheckingDirectDepositAccountResponse?.nested?.DirectDepositNumber && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_direct_deposit_account?.nested?.GetCheckingDirectDepositAccountResponse?.nested?.Error) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetCheckingDirectDepositAccountRequest @ squareup/bbfrontend/common/checking_direct_deposit_account/checking_direct_deposit_account.proto at 14:1
 */
export const GetCheckingDirectDepositAccountRequest = $root.lookupType('squareup.bbfrontend.common.checking_direct_deposit_account.GetCheckingDirectDepositAccountRequest');
fixType(GetCheckingDirectDepositAccountRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetCheckingDirectDepositAccountRequest);
/**
 * SOURCE GetCheckingDirectDepositAccountResponse @ squareup/bbfrontend/common/checking_direct_deposit_account/checking_direct_deposit_account.proto at 19:1
 */
export const GetCheckingDirectDepositAccountResponse = $root.lookupType('squareup.bbfrontend.common.checking_direct_deposit_account.GetCheckingDirectDepositAccountResponse');
fixType(GetCheckingDirectDepositAccountResponse);
Builder.createAndAttachToType(GetCheckingDirectDepositAccountResponse);
/**
 * SOURCE DirectDepositNumber @ squareup/bbfrontend/common/checking_direct_deposit_account/checking_direct_deposit_account.proto at 25:3
 */
GetCheckingDirectDepositAccountResponse.DirectDepositNumber = $root.lookupType('squareup.bbfrontend.common.checking_direct_deposit_account.GetCheckingDirectDepositAccountResponse.DirectDepositNumber');
fixType(GetCheckingDirectDepositAccountResponse.DirectDepositNumber);
Builder.createAndAttachToType(GetCheckingDirectDepositAccountResponse.DirectDepositNumber);
/**
 * SOURCE Error @ squareup/bbfrontend/common/checking_direct_deposit_account/checking_direct_deposit_account.proto at 31:3
 */
GetCheckingDirectDepositAccountResponse.Error = $root.lookupEnum('squareup.bbfrontend.common.checking_direct_deposit_account.GetCheckingDirectDepositAccountResponse.Error').values;